<zef-dialog
  [open]="state.open"
  [autoFocus]="false"
  [options]="{ restoreFocus: false }"
  (closeTrigger)="onClose$.next()">
  <div class="fx:relative">

    <zef-scrollbar
      class="__scroll"
      maxHeight="80vh">
      <div class="__content">
        @if (state.configLoading) {
          <div class="__loading">
            <zui-three-dots />
            <p>Loading configuration...</p>
          </div>
        } @else {
          <z-l7-config-form
            #formRef
            class="__form"
            (submit)="onSubmit$.next()"
            [state]="state.formState"
            [configData]="state.configData"
          />
        }
      </div>
    </zef-scrollbar>

    <div class="__buttons">
      <div class="__buttons-grid">

        <div>
          <zef-progress-error
            full
            [disabled]="!state.formState.isValid || state.configLoading"
            [key]="actionKey">
            <button
              class="c-button--full"
              color="accent"
              [disabled]="!state.formState.isValid || state.configLoading"
              mat-flat-button
              type="button"
              (click)="formRef()?.triggerSubmit()">
              Save Configuration
            </button>
          </zef-progress-error>
        </div>

        <div>
          <button
            (click)="onClose$.next()"
            class="c-button--full"
            type="button"
            mat-button>
            Cancel
          </button>
        </div>

      </div>
    </div>

  </div>
</zef-dialog>
